import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.easing';

import Player from '@vimeo/player';
window.VimeoPlayer = Player;

import './plugins/model-viewer.min.js';
import './templates/quiz.js';

import { dm_reveal } from './config/scroll_reveal';
import { dm_nav } from './components/nav';
import { dm_h01 } from './modules/h01';
import { dm_c04 } from './modules/c04';
import { dm_c05 } from './modules/c05';
import { dm_c07 } from './modules/c07';
import { dm_c08 } from './modules/c08';
import { dm_c10 } from './modules/c10';
import { dm_c11 } from './modules/c11';
import { dm_c12 } from './modules/c12';
import { dm_c14 } from './modules/c14';
import { dm_c16 } from './modules/c16';
import { dm_c17 } from './modules/c17';
import { dm_c19 } from './modules/c19';
import { dm_c20 } from './modules/c20';
import { dm_a02 } from './modules/a02';

import Swiper from 'swiper';
import { Navigation, EffectFade, Autoplay} from 'swiper/modules';
// Swiper.use([Navigation, EffectFade, Autoplay]);

jQuery(function ($) {
    "use strict";

    dm_reveal();
    dm_nav();

    dm_h01();
    dm_c04();
    dm_c05();
    dm_c07();
    dm_c08();
    dm_c10();
    dm_c11();
    dm_c12();
    dm_c14();
    dm_c16();
    dm_c17();
    dm_c19();
    dm_c20();

    dm_a02();


    // document.addEventListener("DOMContentLoaded", function () {
        const first = document.querySelector('.quiz-slide.active');
        if (first) {
            setTimeout(() => first.classList.add('animated'), 50);
        }
    // });
});
